import { render, staticRenderFns } from "./AddGraduationProfileDialog.vue?vue&type=template&id=4c960301"
import script from "./AddGraduationProfileDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddGraduationProfileDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AddGraduationProfileDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports